<template>
    <Header
        elements="9"
        current="3"
    ></Header>
    <NumberPageBlock
        form_type="OA"
        part_url="trademark-office-action"
        part_url_next="step-2"
        deadline_word="Office Action Deadline"
    ></NumberPageBlock>
</template>

<script>
import Header from '@/components/Header-Short-New.vue'
import NumberPageBlock from '@/components/blocks/NumberPageBlock.vue'
import {to_top} from "@/helper";

export default {
    components: {
        Header,
        NumberPageBlock
    },
    data() {
        return {}
    },
    mounted() {
        to_top()
        this.$store.commit('header/setTotal', 0)
    }
}
</script>
